export enum AccountType {
  Developer = 'Developer',
  Business = 'Business',
  Enterprise = 'Enterprise',
}
